import React from 'react';

export interface IContextProps {
  locale: string;
}
export const MyContext = React.createContext({} as IContextProps);
